import { render, staticRenderFns } from "./AdjustComponent.vue?vue&type=template&id=0b24931e&scoped=true"
import script from "./AdjustComponent.vue?vue&type=script&lang=js"
export * from "./AdjustComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24931e",
  null
  
)

export default component.exports